import PatternsApi from '../../apis/Patterns';

export default{
    namespaced: true,
    state: {
        patterns: [],
        pattern_response: null
    },
    mutations: {
        set_patterns (state, data) {
            state.patterns = data;
        },
        set_pattern_response (state, value) {
            state.pattern_response = value;
        }
    },
    actions: {
        setPatterns ({commit}, data) {
            commit('set_patterns', data);
        },
        async getPatterns({commit, dispatch}, filters) {
            commit('set_pattern_response', null);
            return await PatternsApi.get_all(filters)
                .then( response => {
                    commit('set_patterns', response.data)
                })
                .catch( error => {
                    commit('set_pattern_response', 'error');
                })
        },
        async store({commit, dispatch}, pattern) {
            commit('set_pattern_response', null);
            return await PatternsApi.store(pattern)
                .then( response => {
                    commit('set_pattern_response', 'success');
                    dispatch('getPatterns');
                })
                .catch( error => {
                    commit('set_pattern_response', 'error');
                })
        },
        async update({commit, dispatch}, pattern) {
            commit('set_pattern_response', null);
            return await PatternsApi.update(pattern)
                .then( response => {
                    commit('set_pattern_response', 'success');
                    dispatch('getPatterns')
                })
                .catch( error => {
                    commit('set_pattern_response', 'error');
                })
        },
        async change_status({commit, dispatch}, pattern) {
            commit('set_pattern_response', null);
            return await PatternsApi.change_status(pattern)
                .then( response => {
                    commit('set_pattern_response', 'success');
                    dispatch('getPatterns')
                })
                .catch( error => {
                    commit('set_pattern_response', null);
                })
        },
    }
}